import { render, staticRenderFns } from "./myGoods.vue?vue&type=template&id=384cff84&scoped=true"
import script from "./myGoods.vue?vue&type=script&lang=js"
export * from "./myGoods.vue?vue&type=script&lang=js"
import style0 from "./myGoods.vue?vue&type=style&index=0&id=384cff84&prod&lang=css"
import style1 from "./myGoods.vue?vue&type=style&index=1&id=384cff84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384cff84",
  null
  
)

export default component.exports